import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.host.table');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-host-table',
template: templateSource || '',
    styles: [``],
})
export class PortalInfraHostTableComponent implements OnInit {
    @Input() list: any[] = [];
    @Input() loading: boolean = false;
    @Input() pagination: any = { current: 1, start: 0, end: 0 };
    @Input() sortField: string = 'created';
    @Input() sortOrder: string = 'DESC';
    @Output() pageMove = new EventEmitter<number>();
    @Output() sort = new EventEmitter<{ field: string, order: string }>();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public onPageMove(page: number) {
        this.pageMove.emit(page);
    }

    public toggleSort(field: string) {
        let order = 'ASC';
        if (this.sortField === field) {
            order = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        }
        this.sort.emit({ field, order });
    }

    public copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);
        this.service.modal.success('호스트가 클립보드에 복사되었습니다.');
    }
}

export default PortalInfraHostTableComponent;